<template>
  <main-template>
    <v-row>
      <v-col>
        <span class="text-h4">Turmas </span>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pt-0 pb-0">
        <div class="d-flex mb-2 justify-space-between">
          <v-btn color="success" @click="criarTurma" class="mr-2">Criar Turma</v-btn>
          <v-text-field
            v-model="search"
            class="ml-2 search-input"
            append-icon="mdi-magnify"
            label="Pesquisar..."
            solo
            dense
            single-line
            hide-details
          />
        </div>
      </v-col>
      <v-col class="pt-0">
        <v-data-table
          :headers="table.headers"
          :items="turmasList"
          :loading="carregandoTurmas"
          :items-per-page="turmasList.length"
          :custom-filter="dataTableFilter"
          :search="search"
          hide-default-footer
          class="elevation-1"
        >
          <template v-slot:body="{ items }">
            <tbody name="scroll-x-transition" is="transition-group" duration="150">
              <tr
                :class="
                  turma.estaFechada
                    ? 'turma-linha-fechada'
                    : parseInt(turma.notifiq, 10) === 1
                    ? 'green lighten-5'
                    : ''
                "
                v-for="turma of items"
                :key="turma.id"
              >
                <td class="text-left">{{ turma.id }}</td>
                <td class="text-center">{{ turma.codigo }}</td>
                <td class="text-center turma-nome-celula">
                  <v-btn text @click="() => visualizarTurma(turma)">
                    {{ turma.descricao }}
                  </v-btn>
                  <v-chip
                    v-if="parseInt(turma.notifiq, 10) === 1"
                    label
                    class="white--text"
                    color="green darken-4"
                    x-small
                  >
                    NOTIFIQ
                  </v-chip>
                  <div
                    v-if="turma.series.length"
                    class="turma-etapas"
                    :title="turma.series.map((serie) => serie.descricao).join(' · ')"
                  >
                    <span class="turma-etapas__rotulo"
                      >{{ turma.series.length === 1 ? "Etapa" : "Etapas" }}:</span
                    >
                    {{ turma.series.map((serie) => serie.descricao).join(" · ") }}
                  </div>
                </td>
                <td class="text-center">{{ turma.matriculas_count }}/{{ turma.qtd }}</td>
                <td class="text-center">
                  <template v-if="turma.tipo_de_atendimento === 'Escolarização'">
                    <template
                      v-if="
                        turma.limite_prematricula &&
                        turma.prematriculas_count !== null &&
                        turma.prematriculas_count !== undefined
                      "
                    >
                      {{ turma.prematriculas_count }}/{{ turma.limite_prematricula }}
                    </template>
                    <template v-else>
                      {{ turma.prematriculas_count || 0 }}
                    </template>
                  </template>
                </td>
                <td class="text-center">
                  <template v-if="turma.tipo_de_atendimento === 'Escolarização'">
                    <template
                      v-if="
                        turma.limite_prematricula &&
                        turma.prematriculas_count !== null &&
                        turma.prematriculas_count !== undefined
                      "
                    >
                      <v-chip label x-small :color="turma.limite_atingido ? 'error' : 'success'">
                        {{ turma.limite_atingido ? "Atingido" : "Disponível" }}
                      </v-chip>
                    </template>
                    <template v-else>
                      <v-chip label x-small color="success">Disponível</v-chip>
                    </template>
                  </template>
                </td>

                <td class="text-center">
                  <template>
                    <v-chip label x-small :color="turma.estaFechada ? 'error' : 'success'">{{
                      turma.situacao_descricao
                    }}</v-chip>
                  </template>
                </td>

                <td class="text-center turma-acoes-celula">
                  <v-tooltip v-if="!turma.estaDeletado" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        class="ml-1"
                        color="blue-grey lighten-3"
                        v-bind="attrs"
                        v-on="on"
                        @click="() => bolsaFamilia(turma)"
                      >
                        <v-icon small>mdi-human-male-male-child </v-icon>
                      </v-btn>
                    </template>
                    <span>Bolsa Família</span>
                  </v-tooltip>
                  <v-tooltip v-if="!turma.estaDeletado" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        class="ml-1"
                        color="blue-grey lighten-3"
                        v-bind="attrs"
                        v-on="on"
                        @click="() => dashboard(turma)"
                      >
                        <v-icon small>mdi-chart-box </v-icon>
                      </v-btn>
                    </template>
                    <span>Métricas da turma</span>
                  </v-tooltip>
                  <v-tooltip v-if="!turma.estaDeletado && !turma.estaFechada" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        class="ml-1"
                        color="blue-grey lighten-3"
                        v-bind="attrs"
                        v-on="on"
                        @click="() => editarTurma(turma)"
                      >
                        <v-icon small>fa fa-edit </v-icon>
                      </v-btn>
                    </template>
                    <span>Editar turma</span>
                  </v-tooltip>

                  <v-tooltip v-if="!turma.estaDeletado && turma.estaFechada" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        class="ml-1"
                        color="blue-grey lighten-3"
                        v-bind="attrs"
                        v-on="on"
                        @click="() => consultarTurmaFechada(turma)"
                      >
                        <v-icon small>fa fa-eye </v-icon>
                      </v-btn>
                    </template>
                    <span>Visualizar turma</span>
                  </v-tooltip>

                  <v-tooltip v-if="podeAlternarFechamento(turma)" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        class="ml-1"
                        :color="turma.estaFechada ? 'success' : 'blue-grey lighten-3'"
                        v-bind="attrs"
                        v-on="on"
                        @click="() => alternarFechamentoTurma(turma)"
                      >
                        <v-icon small>{{
                          turma.estaFechada ? "fa fa-unlock-alt" : "fa fa-lock"
                        }}</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ turma.estaFechada ? "Reabrir turma" : "Fechar turma" }}</span>
                  </v-tooltip>

                  <v-tooltip v-if="!turma.estaDeletado && $can('turmas.historico')" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        class="ml-1"
                        color="blue-grey lighten-3"
                        v-bind="attrs"
                        v-on="on"
                        @click="() => abrirHistorico(turma)"
                      >
                        <v-icon small>fa fa-history </v-icon>
                      </v-btn>
                    </template>
                    <span>Histórico da turma</span>
                  </v-tooltip>

                  <v-tooltip v-if="!turma.estaDeletado" color="error" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        class="ml-1"
                        color="error"
                        v-bind="attrs"
                        v-on="on"
                        @click="() => deletarTurma(turma)"
                        :disabled="turma.estaFechada"
                      >
                        <v-icon small>fa fa-trash </v-icon>
                      </v-btn>
                    </template>
                    <span>Apagar turma</span>
                  </v-tooltip>

                  <v-tooltip v-if="turma.estaDeletado" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        class="ml-1"
                        color="info"
                        v-bind="attrs"
                        v-on="on"
                        @click="() => recuperarTurma(turma)"
                      >
                        <v-icon small>fa fa-sync </v-icon>
                      </v-btn>
                    </template>
                    <span>Recuperar turma</span>
                  </v-tooltip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>

        <e-paginate
          :current_page="paginate.current_page"
          :last_page="paginate.last_page"
          @changeActionResponse="listarTurmas"
          :search="search"
          :pageNumber="parseInt(pageNumber)"
        >
        </e-paginate>
      </v-col>
    </v-row>
    <e-selecionar-gestao-modal
      :dialog="dialog"
      :turma_id="turma_id"
      @dialogChange="dialog = $event"
    ></e-selecionar-gestao-modal>
    <e-modal-visualizar-turma v-model="visualizarTurmaAberto" :turma="turmaVisualizada" />
    <e-modal-historico-turma v-model="historicoAberto" :turma="turmaDoHistorico" />
  </main-template>
</template>

<script>
// import { mapGetters } from "vuex";
import { dataTableFilter } from "@/plugins/searchQuery";
import Turma from "@/Models/Turma";

export default {
  computed: {
    // ...mapGetters("Turmas", ["turmasList", "carregandoTurmas"]),
  },
  data() {
    return {
      carregandoTurmas: false,
      dialog: false,
      dataTableFilter,
      search: "",
      pageNumber: 0,
      filtroAtual: null,
      visualizarTurmaAberto: false,
      turmaVisualizada: null,
      paginate: {
        current_page: 0,
        last_page: 0,
      },
      turmasList: [],
      turma_id: null,
      historicoAberto: false,
      turmaDoHistorico: null,
      table: {
        headers: [
          { text: "#", value: "id", align: "center" },
          { text: "Código", value: "codigo", align: "center" },
          { text: "Nome", value: "descricao", align: "center" },
          { text: "Matrículas", value: "quantidade", sortable: false, align: "center" },
          {
            text: "Pré-matrículas",
            value: "prematriculas",
            sortable: false,
            align: "center",
          },
          {
            text: "Situação pré-matrículas",
            value: "situacaoprematriculas",
            sortable: false,
            align: "center",
          },
          {
            text: "Situação",
            value: "situacaoturma",
            sortable: false,
            align: "center",
          },
          { text: "Ações", value: "actions", sortable: false, align: "center", width: "215px" },
        ],
      },
    };
  },
  mounted() {
    this.listarTurmas(this.pageNumber);
  },
  watch: {
    carregandoTurmas(value) {
      if (value && this.turmasList.length === 0) {
        this.$loaderService.open("Carregando turmas");
      } else {
        this.$loaderService.close();
      }
    },
    async search(val) {
      if (val.length > 3) {
        await this.listarTurmas(0, val);
      }
      if (!val) {
        await this.listarTurmas(0);
      }
    },
  },
  methods: {
    async listarTurmas(pageNumber, query = null) {
      this.filtroAtual = query;

      this.carregandoTurmas = true;
      this.$loaderService.open("Carregando Turmas");
      try {
        const response = await this.$services.turmasService.syncAllPaginate(pageNumber, query);
        this.turmasList = response.data.map((turma) => new Turma(turma));
        this.paginate = response;
      } catch (error) {
        this.$loaderService.close();
        this.$handleError(error);
      }
      this.carregandoTurmas = false;
      this.$loaderService.close();
    },
    criarTurma() {
      this.$router.push({ name: "turmas.create" });
    },
    visualizarTurma(turma) {
      if (turma.isInfantil) {
        // || parseInt(turma.curso_id, 10) === 3
        this.turma_id = turma.id;
        this.dialog = !this.dialog;
        return;
      }
      this.$router.push({ name: "turmas.view", params: { turma_id: turma.id } });
    },
    consultarTurmaFechada(turma) {
      this.turmaVisualizada = turma;
      this.visualizarTurmaAberto = true;
    },

    editarTurma(turma) {
      this.$router.push({ name: "turmas.edit", params: { turma_id: turma.id } });
      // return turma;
    },
    dashboard(turma) {
      this.$router.push({ name: "turmas.dashboard", params: { id: turma.id } });
      // return turma;
    },
    bolsaFamilia(turma) {
      this.$router.push({ name: "turmas.bolsa_familia", params: { id: turma.id } });
    },
    abrirHistorico(turma) {
      this.turmaDoHistorico = turma;
      this.historicoAberto = true;
    },
    // Fechar e reabrir são permissões distintas: quem só pode reabrir não deve
    // ver o cadeado numa turma aberta, e vice-versa.
    //
    // Sem o curinga `turmas.*` de propósito: ele está em 11 roles, inclusive
    // as que o fechamento não contempla, e as rotas exigem a permissão
    // específica. Aceitá-lo aqui mostraria um botão que a API recusa.
    podeAlternarFechamento(turma) {
      if (turma.estaDeletado) {
        return false;
      }
      return turma.estaFechada ? this.$can("turmas.reabrir") : this.$can("turmas.fechar");
    },
    async deletarTurma(turma) {
      this.$modals.danger({
        title: "Cuidado!",
        message: "Tem certeza que deseja apagar esta turma?",
        confirmationCode: turma.id,
        confirmationMessage: `Por favor, digite <strong>${turma.id}</strong> para confirmar`,
        buttons: [
          {
            text: "Cancelar",
            callback: () => {
              this.$modals.close();
            },
            props: {
              color: "warning",
              small: true,
            },
          },
          {
            text: "Confirmar",
            disableIfCodeDoesntMatch: true,
            callback: async () => {
              this.$modals.close();
              this.$loaderService.open("Deletando a Turma");
              try {
                await this.$services.turmasService.deletarTurma(turma);
                this.$toast.success("Turma deletada com sucesso");
                await this.listarTurmas(this.pageNumber, this.filtroAtual);
                this.$forceUpdate();
              } catch (error) {
                this.$handleError(error);
              }
              this.$loaderService.close();
            },
            props: {
              color: "error",
              // text: true,
              small: true,
            },
          },
        ],
      });
    },
    recuperarTurma(turma) {
      this.$modals.warn({
        title: "Atenção!",
        message: "Tem certeza que deseja recuperar esta turma?",
        confirmationCode: turma.id,
        confirmationMessage: `Por favor, digite <strong>${turma.id}</strong> para confirmar`,
        buttons: [
          {
            text: "Cancelar",
            callback: () => {
              this.$modals.close();
            },
            props: {
              color: "warning",
              small: true,
            },
          },
          {
            text: "Confirmar",
            disableIfCodeDoesntMatch: true,
            callback: async () => {
              this.$modals.close();
              this.$loaderService.open("Recuperando a Turma");
              try {
                await this.$services.turmasService.recuperarTurma(turma);
                this.$toast.success("Turma recuperada com sucesso");
                this.$forceUpdate();
              } catch (error) {
                this.$handleError(error);
              }
              this.$loaderService.close();
            },
            props: {
              color: "error",
              // text: true,
              small: true,
            },
          },
        ],
      });
    },
    // Operações que o fechamento congela — e que a reabertura libera de novo.
    // A lista vem da especificação do fechamento de turma (ticket 7467).
    operacoesAfetadasPeloFechamento() {
      return [
        "Criar/editar avisos",
        "Criar/editar/deletar matrículas de alunos",
        "Criar/editar/deletar/efetivar pré-matrículas de alunos",
        "Transferir/remanejar alunos de turmas",
        "Editar/deletar turmas",
        "Registrar/alterar justificativas no Bolsa Família",
        "Alterar frequência mínima do Bolsa Família",
        "Criar/alterar planos",
        "Lançar/alterar notas",
        "Criar/editar/deletar/duplicar/exportar aulas do infantil/fundamental/EJA no sistema web e aplicativo",
        "Lançar frequência no sistema web e aplicativo",
        "Criar/editar/deletar gestão de aula",
        "Criar/editar agendas",
        "Criar/editar/deletar gestão AEE",
        "Criar/editar/deletar atendimento AEE",
        "Criar/editar histórico",
      ];
    },
    mensagemFechamento(turma, vaiFechar) {
      const itens = this.operacoesAfetadasPeloFechamento()
        .map((item) => `<li style="break-inside: avoid; margin-bottom: 4px;">${item}</li>`)
        .join("");

      const acao = vaiFechar ? "Fechar" : "Reabrir";
      const efeito = vaiFechar
        ? "Enquanto estiver fechada, a turma não permitirá:"
        : "Ao reabrir, a turma voltará a permitir:";

      const pendentes = vaiFechar ? turma.prematriculas_pendentes_count || 0 : 0;
      const avisoPendencias = pendentes
        ? `<p class="mb-4 error--text"><strong>${
            pendentes === 1
              ? "Esta turma possui 1 pré-matrícula pendente"
              : `Esta turma possui ${pendentes} pré-matrículas pendentes`
          }.</strong> Efetive ou exclua ${
            pendentes === 1 ? "a pendência" : "as pendências"
          } antes de fechar a turma.</p>`
        : "";

      return `
        ${avisoPendencias}
        <p class="mb-4">${efeito}</p>
        <ul style="column-width: 260px; column-gap: 28px; padding-left: 18px; margin: 0; margin-botom: 24px; font-size: 0.75rem; line-height: 1.5;">
          ${itens}
        </ul>
      `;
    },
    alternarFechamentoTurma(turma) {
      const vaiFechar = !turma.estaFechada;
      this.$modals.warn({
        title: vaiFechar ? "Fechar turma" : "Reabrir turma",
        message: this.mensagemFechamento(turma, vaiFechar),
        maxWidth: "760px",
        confirmationCode: turma.id,
        confirmationMessage: `Por favor, digite <strong>${turma.id}</strong> para confirmar`,
        buttons: [
          {
            text: "Cancelar",
            callback: () => {
              this.$modals.close();
            },
            props: {
              color: "warning",
              small: true,
            },
          },
          {
            text: "Confirmar",
            disableIfCodeDoesntMatch: true,
            callback: async () => {
              this.$modals.close();
              this.$loaderService.open(vaiFechar ? "Fechando a Turma" : "Reabrindo a Turma");
              try {
                if (vaiFechar) {
                  await this.$services.turmasService.fecharTurma(turma);
                  this.$toast.success("Turma fechada com sucesso");
                } else {
                  await this.$services.turmasService.reabrirTurma(turma);
                  this.$toast.success("Turma reaberta com sucesso");
                }
                await this.listarTurmas(this.pageNumber, this.filtroAtual);
              } catch (error) {
                this.$handleError(error);
              }
              this.$loaderService.close();
            },
            props: {
              color: "success",
              small: true,
            },
          },
        ],
      });
    },
  },
};
</script>

<style scoped>
/* Etapas da turma, abaixo do nome: secundário ao nome, não compete com ele. */
/* A célula respira em volta do nome, para a área de clique do botão
   ficar visualmente delimitada no hover. O seletor carrega o td porque
   o Vuetify já estiliza `.v-data-table td` e venceria a classe sozinha. */
td.turma-nome-celula {
  padding-top: 8px;
  padding-bottom: 8px;
}

/* Cabeçalhos em duas linhas quando necessário, em vez de esticar a coluna. */
.v-data-table ::v-deep th {
  white-space: normal;
  line-height: 1.25;
}

/* Turma fechada é o fim normal do ciclo letivo, não um erro: cinza lê como
   "encerrada", enquanto o vermelho anterior sugeria problema. O seletor
   carrega `tr` para vencer o hover que o Vuetify aplica na linha. */
.v-data-table ::v-deep tr.turma-linha-fechada {
  background-color: #d8d8d886;
}

.v-data-table ::v-deep tr.turma-linha-fechada:hover {
  background-color: #d8d8d886 !important;
}

/* Os botões de ação ficam numa linha só. Em notebook a coluna encolhe e eles
   embrulhariam em três linhas, triplicando a altura de cada turma. */
.turma-acoes-celula {
  white-space: nowrap;
}

.turma-etapas {
  /* 11px: texto de apoio. O letter-spacing compensa a legibilidade
     que se perde nesse tamanho. */
  font-size: 0.6875rem;
  line-height: 1.35;
  letter-spacing: 0.01em;
  color: rgba(0, 0, 0, 0.72);
  margin-top: 2px;
  /* Uma linha só, com reticências: em notebook uma turma multietapa
     quebraria em duas linhas e desalinharia a altura das demais. */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Rótulo mais apagado que o valor: o olho pousa na etapa, não na palavra. */
.turma-etapas__rotulo {
  color: rgba(0, 0, 0, 0.45);
}
</style>
